<template>
  <b-container fluid id="main-container">
    <b-row>
      <b-col xs=12>
        <div class="gradio-container">
          <iframe
            ref="gradioIframe"
            :src="gradioUrl"
            frameborder="0"
            scrolling="no"
            style="width: 100%; min-height: 2500px; border: none;"
            allow="microphone; camera">
          </iframe>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "MorphologicalSegmentation",
  data() {
    return {
      gradioUrl: 'http://localhost:5100/'
    };
  }
};
</script>

<style lang="scss" scoped>
.gradio-container {
  width: 100%;
  min-height: 2500px;
}
</style>
